module.exports = __webpack_public_path__ + "img/10.b8de8f38.png";